__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "rapaydo";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "19.0.6", () => (__webpack_require__.e(6443).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "19.0.6", () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core/primitives/event-dispatch", "19.0.6", () => (__webpack_require__.e(6745).then(() => (() => (__webpack_require__(6745))))));
			register("@angular/core/primitives/signals", "19.0.6", () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core/rxjs-interop", "19.0.6", () => (__webpack_require__.e(6693).then(() => (() => (__webpack_require__(9074))))));
			register("@angular/core", "19.0.6", () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(7580))))));
			register("@angular/forms", "19.0.6", () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(4456))))));
			register("@angular/router", "19.0.6", () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(5072))))));
			register("@ngx-translate/core", "16.0.4", () => (__webpack_require__.e(884).then(() => (() => (__webpack_require__(8503))))));
			register("@ngx-translate/http-loader", "16.0.1", () => (__webpack_require__.e(4660).then(() => (() => (__webpack_require__(2279))))));
			register("@rapaydo/rapaydo-form-controls", "1.1.9", () => (__webpack_require__.e(1822).then(() => (() => (__webpack_require__(9441))))));
			register("@rapaydo/shared/remote-assets", "1.1.9", () => (__webpack_require__.e(1095).then(() => (() => (__webpack_require__(3476))))));
			register("rxjs/operators", "7.8.1", () => (__webpack_require__.e(3620).then(() => (() => (__webpack_require__(3620))))));
			register("rxjs", "7.8.1", () => (__webpack_require__.e(1340).then(() => (() => (__webpack_require__(1340))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};